import _ from 'lodash';
import { useMemo } from 'react';

import { AutoAwesomeOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useRevenueDeepDiveButtonQuery } from 'generated/graphql';



export type RevenueDeepDiveButtonProps = {
  companyId: string;
  variant: 'chat' | 'companyProfile';
  onClick?: () => void;
};

export const FC = ({
  companyId, variant, onClick
}: RevenueDeepDiveButtonProps) => {
  const {
    data, loading
  } = useRevenueDeepDiveButtonQuery({
    variables: {
      companyId: companyId
    }
  });

  const sx = variant === 'companyProfile' ? {
    backgroundColor: '#D4AF37',
    boxShadow: '#D4AF37 0px 2px 2px 0px'
  } : {
    backgroundColor: '#D4AF37',
    boxShadow: '#D4AF37 0px 2px 2px 0px',
    height: '40px',
    borderRadius: '8px'
  };

  const hasDeepDive = useMemo(() => {
    const topics = data?.listedCompany?.revenueDeepDive ?? [];
    return !_.isEmpty(topics);
  }, [data]);

  return (
    <Button
      disabled={loading || !hasDeepDive}
      size='small'
      sx={sx}
      variant='contained'
      endIcon={!loading && <AutoAwesomeOutlined fontSize='small' />}
      onClick={onClick ? onClick : () => {
        window.open(`/company/${companyId}/revenueDeepDive`, '_blank');
      }}
    >
      {loading ? 'Retrieving...' : 'Revenue Deep Dive'}
    </Button>
  );
};
